import { useRouter } from 'next/router';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Head from 'next/head';

import { FullScreenLoader } from '../../../components/FullScreenLoader';
import { RestaurantMain } from '../../components/RestaurantMain';

const Menu = () => {
    const router = useRouter();
    const { restaurantId } = router.query;
    const { t } = useTranslation('restaurant.menu');
    if (typeof restaurantId !== 'string') return <FullScreenLoader componentOrShow={false} />;

    return (
        <>
            <Head>
                <title>{t('title')}</title>
                <link href="https://fonts.googleapis.com" rel="preconnect" />
                <link href="https://fonts.googleapis.com/css2?family=Space+Grotesk&display=swap" rel="stylesheet" />
            </Head>
            <RestaurantMain page="menu" restaurantId={restaurantId} />
        </>
    );
};

export default Menu;
